import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { isUndefined, omitBy } from "lodash-es";
import { Observable } from "rxjs";
import {
  AttachmentV2,
  AttachmentV2Update
} from "src/app/backend/models/attachment/attachment";
import { UserNotify } from "src/app/support/notify-decorator";
import { environment } from "src/environments/environment";

@Injectable()
export class AttachmentBillingBackend {
  private readonly http = inject(HttpClient);

  load(id: string): Observable<AttachmentV2> {
    return this.http.get<AttachmentV2>(
      `${environment.snoots.api.billing}/attachments/${id}`
    );
  }

  @UserNotify({
    successMessage: marker("Documento rimosso"),
    errorMessage: marker("Non è stato possibile rimuovere il documento")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.billing}/attachments/${id}`
    );
  }

  @UserNotify({
    successMessage: marker("Documento aggiornato"),
    errorMessage: marker("Non è stato possibile aggiornare il documento")
  })
  update(id: string, payload: AttachmentV2Update): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.billing}/attachments/${id}`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Documento inviato"),
    errorMessage: marker("Impossibile inviare il documento")
  })
  send(
    id: string,
    payload: {
      email: string;
      customerId: string;
      patientName?: string;
      contentType: string;
      notes?: string;
    }
  ): Observable<void> {
    return this.http.put<void>(
      `${environment.snoots.api.billing}/attachments/${id}/send`,
      omitBy(payload, isUndefined)
    );
  }
}
